import React from 'react';
import DepartmentDetails from './DepartmentDetails';

const Departments = () => {
    return (
        <div>
            <DepartmentDetails/>
        </div>
    );
};

export default Departments;